import React from "react";
import { IoDiamond, IoRocket, IoTelescope } from "react-icons/io5";
import AboutCard from "./AboutCard";
import "./SecondPara.css";

function SecondPara() {
  return (
    <section className="beliefs-section">
      <div className="beliefs-header">
        <h1 className="beliefs-heading">Our Beliefs</h1>
      </div>

      <div className="beliefs-cards">
        <AboutCard
          heading="Mission"
          subheading="To bring inspiration and innovation to every corner of the world. Starting from legal to travel to entertainment sectors, our mission is to help unleash the potential of every team through collaboration and best-in-class services."
          Icon={IoRocket}
        />

        <AboutCard
          heading="Vision"
          subheading="Our vision is to create a better everyday life for many people — clients and co-workers alike — by delivering innovation-driven solutions at sustainable prices."
          Icon={IoDiamond}
        />

        <AboutCard
          heading="Values"
          subheading="Our core values form the DNA of our company — guiding beliefs, ethics, and principles that shape every decision and every partnership."
          Icon={IoTelescope}
        />
      </div>
    </section>
  );
}

export default SecondPara;
